module.exports = __webpack_public_path__ + "static/media/Star.7c9e379e.svg";